<script setup>
import { ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

defineProps({
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  confirmLabel: { type: String, default: '' },
  // "alert" paints the confirm button red, for destructive actions.
  type: { type: String, default: 'alert' },
});

const emit = defineEmits(['confirm', 'close']);

const dialogRef = ref(null);

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

const onConfirm = () => {
  close();
  emit('confirm');
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :type="type"
    width="md"
    :title="title"
    :description="description"
    :confirm-button-label="confirmLabel"
    @confirm="onConfirm"
    @close="emit('close')"
  />
</template>
